export default (phoneNumber) => phoneNumber
  .replace('(', '')
  .replace(')', '')
  .replace('-', '') // TODO: come back and fix: shouldn't have to repeat this dash replace for second dash
  .replace(' ', '')
  .replace('-', '');
